'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyContentCard: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.contentCards')
  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-user-content-illustration.svg"
      variant="base"
    />
  )
}
